import { useLocation } from "react-router-dom";

const Header = ({ t, lang, setLang, hideLang }) => {
  const { pathname } = useLocation();
  const home = pathname === "/";
  const go = (id) => (home ? `#${id}` : `/#${id}`);
  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner">
        <a className="brand" href={home ? "#home" : "/"} data-testid="header-brand-logo">
          <svg className="brand-mark" viewBox="0 0 64 64" aria-hidden="true">
            <circle cx="32" cy="32" r="29" fill="none" stroke="#D6A75F" strokeWidth="2.5" opacity="0.7" />
            <text x="32" y="41" textAnchor="middle" fontFamily="Georgia, serif" fontStyle="italic" fontSize="26" fill="#D6A75F">CS</text>
          </svg>
          <span>CINDY SILVA<i className="dot">.</i></span>
        </a>
        <nav aria-label="Principal">
          <a href={go("services")} data-testid="nav-services-link">{t.navServices}</a>
          <a href={go("work")} data-testid="nav-work-link">{t.navWork}</a>
          <a href={go("about")} data-testid="nav-about-link">{t.navAbout}</a>
          <a href={go("contact")} data-testid="nav-contact-link">{t.navContact}</a>
        </nav>
        {hideLang ? null : (
          <div className="languages" role="group" aria-label="Idioma / Language">
            <button type="button" data-testid="lang-es-btn" aria-pressed={lang === "es"} onClick={() => setLang("es")}>ES</button>
            <button type="button" data-testid="lang-en-btn" aria-pressed={lang === "en"} onClick={() => setLang("en")}>EN</button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
